import { DateTime } from 'luxon';

export const validate = (dayToValidate: string, monthToValidate: string, yearToValidate: string, allowBlank: boolean) => {
    if (dayToValidate === "" && monthToValidate === "" && yearToValidate === "") {
        return allowBlank;
    }
    if (!allowBlank && (dayToValidate === "" || monthToValidate === "" || yearToValidate === "")) {
        return false;
    }
    const yearInt = parseInt(yearToValidate, 10);
    const monthInt = parseInt(monthToValidate, 10);
    const dayInt = parseInt(dayToValidate, 10);
    if (isNaN(yearInt) || isNaN(monthInt) || isNaN(dayInt)) {
        return false;
    }
    const dateToTest = DateTime.local(yearInt, monthInt, dayInt);
    return dateToTest.isValid;
};


// WEBPACK FOOTER //
// ./src/CustomHooks/useDateConverter.ts